import {DumpsterFire} from "../../DumpsterFire";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";


export class DFAvalancheBetPresentation implements FlowStatePresentation {
    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => flowStateController.finish()
        });
        if (DumpsterFire.model.data.nextMode === DumpsterFireGameMode.NORMAL_AVALANCHE) {
            DumpsterFire.model.nearWinReels = [false, false, false, false, false, false];
        }
        if (tl.duration() == 0) {
            tl.add(gsap.to(this, {duration: 0.001}));
        }
    }
}